import { IAriaLabels } from '@models/IAriaLabels';
import useAriaLabelsStore from '@state/AriaLabelsStore';
import initialAriaLabels from '@utils/mocks/ariaLabels.mocks';
import { useEffect, useState } from 'react';

const useAriaLabels = () => {
  const [ariaLabels, setAriaLabels] = useState<IAriaLabels>(initialAriaLabels);
  const ariaLabelsFromStore = useAriaLabelsStore((state) => state.ariaLabels);

  useEffect(() => {
    setAriaLabels(ariaLabelsFromStore);
  }, [ariaLabelsFromStore]);

  return ariaLabels;
};

export default useAriaLabels;
